import { useLocaleMapping } from "@/Composables/useLocaleMapping";

export const useDuration = () => {
    const { mappedLocale } = useLocaleMapping();

    const formatDuration = (duration = 0, inputUnit = "seconds") => {
        if (!inputUnit) return duration;
        if (inputUnit !== "seconds") {
            switch (inputUnit) {
                case "minutes":
                    duration *= 60;
                    break;
                case "hours":
                    duration *= 3600;
                    break;
                case "days":
                    duration *= 86400;
                    break;
                default:
                    break;
            }
        }
        // If the browser does not support the Intl.DurationFormat API, we will use our own implementation
        // at the moment only Safari and Safari mobile support this beautiful API, but hopefully more browsers will follow
        if (typeof Intl.DurationFormat === "undefined") {
            return _fromSecondsFallback(duration);
        } else {
            return new Intl.DurationFormat(mappedLocale.value, {
                style: "narrow",
                minutesDisplay: "always",
            }).format({
                seconds: duration % 60,
                minutes: Math.floor(duration / 60) % 60,
                hours: Math.floor(duration / 3600) % 60,
                days: Math.floor(duration / 86400),
            });
        }
    };

    // at the moment, english only
    // @todo: translate this to other languages
    const _fromSecondsFallback = (duration) => {
        if (duration < 0) duration = -duration;
        if (duration === 0) return "—";
        const time = {
            d: Math.floor(duration / 86400),
            h: Math.floor(duration / 3600) % 24,
            min: Math.floor(duration / 60) % 60,
            s: Math.floor(duration) % 60,
        };
        return Object.entries(time)
            .filter((val) => val[1] !== 0)
            .map(([key, val]) => `${val}${key}`)
            .join(" ");
    };
    return {
        formatDuration,
    };
};
